"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AltiumHiddenNetNameGroupingRule = void 0;
const NetNamingRules_1 = require("../../../../NetCombobulation/NetNamingRules");
const project_1 = require("../../project");
const AltiumLabelTypeNameUtil_1 = require("./AltiumLabelTypeNameUtil");
class AltiumHiddenNetNameGroupingRule {
    constructor(config) {
        this.config = config;
        this.type = NetNamingRules_1.NetNamingRuleType.Group;
    }
    apply(manager, _hierarchy) {
        const globalScope = Symbol('global-hidden-power-scope');
        const isStrictHierarchical = this.config.mode === project_1.HierarchyMode.StrictHierarchical;
        const groupsByName = new Map();
        for (const group of manager.findGroupsWithLabel('net-label')) {
            for (const [instance, nets] of group.getNets()) {
                for (const net of nets) {
                    for (const label of net.labels) {
                        const hiddenNetName = label.strategyMetadata?.hiddenNetName;
                        if (label.labelType !== 'net-label' || hiddenNetName === undefined) {
                            continue;
                        }
                        const key = hiddenNetName.toLowerCase();
                        const entry = groupsByName.get(key) ?? { groups: new Set(), scopes: new Set() };
                        entry.groups.add(group);
                        entry.scopes.add(isStrictHierarchical ? instance : globalScope);
                        groupsByName.set(key, entry);
                    }
                }
            }
        }
        for (const group of manager.findGroupsWithLabel('power-port')) {
            for (const [instance, nets] of group.getNets()) {
                for (const net of nets) {
                    for (const label of net.labels) {
                        if (label.labelType !== 'power-port' || label.formattedLabel === undefined) {
                            continue;
                        }
                        const scope = isStrictHierarchical ? instance : globalScope;
                        const formattedName = AltiumLabelTypeNameUtil_1.AltiumLabelTypeNameUtil.maybeDereferenceLabelName(label.formattedLabel);
                        if (formattedName.toLowerCase() !== label.originalLabel.toLowerCase()) {
                            continue;
                        }
                        const entry = groupsByName.get(formattedName.toLowerCase());
                        if (entry?.scopes.has(scope)) {
                            entry.groups.add(group);
                        }
                    }
                }
            }
        }
        for (const { groups } of groupsByName.values()) {
            const [firstGroup] = groups;
            if (firstGroup === undefined) {
                continue;
            }
            manager.mergeGroups(...groups);
        }
        return manager;
    }
}
exports.AltiumHiddenNetNameGroupingRule = AltiumHiddenNetNameGroupingRule;
//# sourceMappingURL=AltiumHiddenNetNameGroupingRule.js.map